export function withSlices(...configs) {
    return (set) => {
        const state = {};
        for (const config of configs) {
            state[config.name] = config.value;
            for (const [actionName, actionFn] of Object.entries(config.actions)) {
                state[actionName] = (...args) => {
                    set(((prevState) => {
                        const prevSlice = prevState[config.name];
                        const nextSlice = actionFn(...args)(prevSlice);
                        if (Object.is(prevSlice, nextSlice)) {
                            return prevState;
                        }
                        return { [config.name]: nextSlice };
                    }));
                };
            }
        }
        return state;
    };
}
